import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';

/**
 * A component that provides two select-elements for setting the sorting-type and sorting-direction.
 * Provides sorting according to CREATION_DATE, MODIFICATION_DATE and NAME.
 * @param {*} param0 
 * @returns 
 */
export default function SortingBar({ onChangeSortType, onChangeSortDir, defaultSortType = 'CREATION_DATE', defaultSortDir = "DESC" }) {
  const [sortType, setSortType] = useState(defaultSortType);
  const [sortDir, setSortDir] = useState(defaultSortDir);

  // language-translations
  const intl = useIntl();

  /**
  * Should be called when the sorting-type is changed.
  * @param {*} event 
  */
  const handleChangeSortType = (event) => {
    setSortType(event.target.value);
    onChangeSortType(event.target.value);
  }

  /**
   * Should be called when the sorting-direction is changed.
   * @param {*} event 
   */
  const handleChangeSortDir = (event) => {
    setSortDir(event.target.value);
    onChangeSortDir(event.target.value);
  }

  return (
    <Box sx={{ marginBottom: 1 }} >
      <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
        <InputLabel id="sorting-type-select-standard-label"><FormattedMessage id="Overview.sortBy" /></InputLabel>
        <Select
          labelId="sorting-type-select-standard-label"
          id="sorting-type-select-standard"
          value={sortType}
          onChange={handleChangeSortType}
          label={intl.formatMessage({ id: "Overview.sortBy" })}
        >
          <MenuItem value="CREATION_DATE">
            <em><FormattedMessage id="Overview.creationTime" /></em>
          </MenuItem>
          <MenuItem value="MODIFICATION_DATE" >
            <em><FormattedMessage id="Overview.modificationTime" /></em>
          </MenuItem>
          <MenuItem value="NAME">
            <em><FormattedMessage id="Overview.name" /></em>
          </MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
        <InputLabel id="sorting-direction-select-standard-label"><FormattedMessage id="Overview.sortDirection" /></InputLabel>
        <Select
          labelId="sorting-direction-select-standard-label"
          id="sorting-direction-select-standard"
          value={sortDir}
          onChange={handleChangeSortDir}
          label={intl.formatMessage({ id: "Overview.sortDirection" })}
        >
          <MenuItem value="DESC">
            <em><FormattedMessage id="Overview.desc" /></em>
          </MenuItem>
          <MenuItem value="ASC">
            <em><FormattedMessage id="Overview.asc" /></em>
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}